import React, {useCallback, useState} from 'react';
import {
    Page, Card, TextField, Form, FormLayout, Button
} from '@shopify/polaris';
//import axios from 'axios';

function Install(props: any){
    const [textFieldValue, setTextFieldValue] = useState('');
    console.log('props',props)
    const handleTextFieldChange = useCallback(
      (value) => setTextFieldValue(value),
      [],
    );

    const handleSubmit = useCallback((_event) => {
        //https://6adcb5a5.ngrok.io
        //const serverInstallUrl = 'http://localhost:5000/shopify?shop=' + textFieldValue + '.myshopify.com';
        const host = '';//'https://66468383.ngrok.io'; //window.location.origin;
        const serverInstallUrl = `${host}/shopify?shop=${textFieldValue}.myshopify.com`;
        console.log('serverInstallUrl', serverInstallUrl);


        /*axios({
            method: 'get',
            url: '/api/'
        }).then((res) => {
            console.log(res.data);
        }, (err) => {
            console.log(err);
        });*/
        window.location.assign(serverInstallUrl);
    }, [textFieldValue]);

    const handleClearButtonClick = useCallback(() => setTextFieldValue(''), []);

    return (
        <Page>
            <Card title="Install on your store" sectioned>
                <p>View a summary of your online store’s performance.</p><br/>
                <Form onSubmit={handleSubmit}>
                    <FormLayout>
                        <TextField
                            label="Store Url"
                            type="text"
                            value={textFieldValue}
                            onChange={handleTextFieldChange}
                            placeholder="my-shop"
                            suffix=".myshopify.com"
                            clearButton
                            onClearButtonClick={handleClearButtonClick}
                            helpText={
                                <span>
                                We’ll use this email address to inform you on future changes to
                                Polaris.
                                </span>
                            }
                        />

                        <Button submit primary>Install</Button>
                    </FormLayout>
                </Form>
            </Card>
        </Page>
    );
}

export default Install;